import { render, staticRenderFns } from "./CorrelationForm.vue?vue&type=template&id=2713e769&scoped=true"
import script from "./CorrelationForm.vue?vue&type=script&lang=ts"
export * from "./CorrelationForm.vue?vue&type=script&lang=ts"
import style0 from "./CorrelationForm.vue?vue&type=style&index=0&id=2713e769&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2713e769",
  null
  
)

export default component.exports